import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import Modal from './Modal';
import ZoomableImage from './ZoomableImage';
import ModalCloseButton from './ModalCloseButton';
import { useDispatch } from 'react-redux';
import { closeImageModal } from '../../store/modal/imageModalSlice';

/**
 * Modal for Images
 */

function ImageModal({ imageURL }) {
  const dispatch = useDispatch();
  const [isZoomed, setIsZoomed] = useState(false);

  function closeModal() {
    dispatch(closeImageModal());
  }

  return (
    <Modal onCloseRequest={closeModal} forImage>
      <ZoomableImage
        src={imageURL}
        alt="Zoomable image"
        className="image"
        onZoomChange={setIsZoomed}
      />
      <ModalCloseButton onCloseRequest={closeModal} shouldHide={isZoomed} />
    </Modal>
  );
}

ImageModal.propTypes = {
  imageURL: PropTypes.string.isRequired,
};

export default ImageModal;
